export enum SecuredResources {
  Progress = 'Progress',
  ProgressStage = 'ProgressStage',
  ActivityHistory = 'ActivityHistory'
}
